var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSortingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0L10 7 0 7z",
    transform: "matrix(1 0 0 -1 0 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortingDown);
export default __webpack_public_path__ + "static/media/icon-sorting-down.e58b2203c91589b761aad6d2df8e01e1.svg";
export { ForwardRef as ReactComponent };